import { useQueryClient } from '@tanstack/react-query';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';

interface ChangeVoiceScanImageProps {
  open: boolean;
  onClose: () => void;
}

export default function ChangeVoiceScanImageDialog({
  open,
  onClose,
}: ChangeVoiceScanImageProps) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const onChange = () => {
    queryClient.invalidateQueries({ queryKey: ['voice-scan-image'] });
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className={cn('max-w-md px-4 py-6 sm:p-8')}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideClose
      >
        <DialogHeader>
          <DialogTitle className='text-center'>
            {t('voice_image_change_title')}
          </DialogTitle>
          <DialogDescription className='mt-2 text-base text-center'>
            {t('voice_image_change_info')}
          </DialogDescription>
        </DialogHeader>

        <div className='mt-2 '>
          <div className='flex flex-col justify-center gap-4 md:flex-row'>
            <Button onClick={onChange} className='text-sm h-9'>
              {t('yes_change_image')}
            </Button>
            <Button
              variant='outline'
              onClick={onClose}
              className='w-full text-sm border-gray-500 lg:w-24 h-9'
            >
              {t('cancel')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
